import styles from './ConsultingDetail.module.css';
import SubPageTop from '../../components/SubPageTop';
import ScrollReveal from '../../components/Ui/ScrollReveal';

const brandingProcessData = [
    {
        id: 1,
        step: '01',
        title: '개인분석',
        description: '고객, 본인의 비전, 장단점, 매력, 경쟁요소, 재능, 가치관 등 세부 사항 분석'
    },
    {
        id: 2,
        step: '02',
        title: '퍼스널 아이덴티티 수립',
        hasIdentityFlow: true,
        identitySteps: [
            { label: '내적 이미지 분석', color: '#d4d4d4' },
            { label: '내적 이미지 분석', color: '#c8e6a0' },
            { label: '내적 이미지 분석', color: '#5bbfc7' }
        ],
        flowResult: '개인의 핵심 아이덴티티 도출'
    },
    {
        id: 3,
        step: '03',
        title: '요소개발',
        description: 'SNS, 홈페이지, 개인 프로필, 내외적 이미지 등 퍼스널브랜딩이 적용가능한 툴 선정 및 적용'
    }
];


function PersonalBranding() {
    return (
        <div className={styles.consultingDetail}>
            <SubPageTop title="Consulting" />
            <div className={styles.consultingDetailContent}>
                <ScrollReveal>
                    <section className={styles.section01}>
                    <div className={styles.imgbox}>
                        <img
                            src="/image/consulting-detail-section01-09.png"
                            alt="컬러 이미지"
                        />
                    </div>
                    <div className={styles.infoBox}>
                        <div className={styles.infoHeader}>
                            <p className={styles.subtitle}>
                                Color Consulting
                            </p>
                            <p className={styles.koTitle}>
                                퍼스널 브랜딩 컨설팅
                            </p>
                        </div>
                        <div className={styles.infoDetail}>
                            <div className={styles.infoDesc}>
                                퍼스널 브랜딩 컨설팅은,
                                <br />
                                개인의 아이덴티티를 찾을 수 있도록 비전, 매력 등을 분석하여
                                개인 브랜딩 및 유지관리를 돕는 프로그램입니다.
                            </div>
                            {/*       <ul className={styles.infoList}>
                                <li>
                                    <span className={styles.pointcolor}>·</span>
                                    <span>브랜드 및 기관의 정체성과 이미지 확립에 바람직한 도움이 되고자 건축물 및 조경환경을 대상으로 하는 색채 사용 기준 제시</span>
                                </li>
                                <li>
                                    <span className={styles.pointcolor}>·</span>
                                    <span>
                                        색채의 활용으로 차별화 된 환경 디자인의 기준을 마련하며, 지향 이미지를 바탕으로 향후 계획에 필요한 색채 팔레트 메뉴얼 제안
                                    </span>
                                </li>
                                <li>
                                    <span className={styles.pointcolor}>·</span>
                                    <span>심미성, 편리성, 생활을 고려한 환경 색채디자인으로 건물, 공간 및 브랜드에 대한 긍정적 이미지 부여 및 쾌적성, 편리성, 안정성을 도모하여 심리적 편안함 제공</span>
                                </li>
                            </ul> */}
                        </div>
                    </div>
                </section>
                </ScrollReveal>
                <ScrollReveal>
                    <section className={styles.section02}>
                    <div className={styles.titleWrap}>
                        <p className={styles.programSubtitle}>process</p>
                        <h2 className={styles.title}>컨설팅 프로세스</h2>
                    </div>
                    <div className={styles.line}></div>
                    <div className={styles.brandingWrapper}>
                        {brandingProcessData.map((item) => (
                            <div key={item.id} className={styles.brandingRow}>
                                <div className={styles.brandingStepBox}>
                                    <h3 className={styles.brandingStepTitle}>
                                        {item.step} {item.title}
                                    </h3>
                                </div>
                                <div className={styles.brandingContentBox}>
                                    {item.description && (
                                        <p className={styles.brandingDesc}>{item.description}</p>
                                    )}
                                    {item.hasIdentityFlow && (
                                        <div className={styles.brandingIdentityFlow}>
                                            {item.identitySteps.map((step, index) => (
                                                <div key={index} className={styles.brandingIdentityItem}>
                                                    <div
                                                        className={styles.brandingIdentityBox}
                                                        style={{ backgroundColor: step.color }}
                                                    >
                                                        <span className={styles.brandingIdentityLabel}>
                                                            {step.label}
                                                        </span>
                                                    </div>
                                                    {index < item.identitySteps.length - 1 && (
                                                        <div className={styles.brandingIdentityArrow}>▶</div>
                                                    )}
                                                </div>
                                            ))}
                                            <div className={styles.brandingIdentityResult}>
                                                <div className={styles.brandingIdentityArrow}>▶</div>
                                                <span className={styles.brandingIdentityResultText}>
                                                    {item.flowResult}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
                </ScrollReveal>
            </div>
        </div>
    );
}

export default PersonalBranding;

